import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { apiClient } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState({ new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.new_password.length < 6) { toast.error("Au moins 6 caractères."); return; }
    if (pw.new_password !== pw.confirm) { toast.error("Les deux mots de passe ne correspondent pas."); return; }
    setBusy(true);
    try {
      await apiClient.post("/auth/reset-password", { token, new_password: pw.new_password });
      setDone(true);
      toast.success("Mot de passe réinitialisé.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Lien invalide ou expiré.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0F0D] text-white flex flex-col px-5 py-8">
      <div className="max-w-sm w-full mx-auto">
        <Logo size="lg" />
        <h1 className="font-display text-3xl font-black mt-8 mb-2">Nouveau mot de passe</h1>
        {!token ? (
          <p data-testid="reset-invalid-message" className="text-sm text-white/60 mt-3">Lien invalide. Refais une demande depuis « Mot de passe oublié ».</p>
        ) : done ? (
          <div data-testid="reset-done-message" className="mt-4 space-y-4">
            <p className="text-sm text-white/70">Ton mot de passe a été mis à jour. Tu peux te connecter.</p>
            <button data-testid="reset-goto-login" onClick={() => navigate("/login")}
              className="w-full bg-lime-400 text-black font-extrabold py-3.5 rounded-xl">Se connecter</button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3 mt-4">
            <input data-testid="reset-new-password-input" type="password" placeholder="Nouveau mot de passe" value={pw.new_password}
              onChange={(e) => setPw((p) => ({ ...p, new_password: e.target.value }))}
              className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3.5 text-sm outline-none focus:border-lime-400/50" />
            <input data-testid="reset-confirm-password-input" type="password" placeholder="Confirme le mot de passe" value={pw.confirm}
              onChange={(e) => setPw((p) => ({ ...p, confirm: e.target.value }))}
              className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3.5 text-sm outline-none focus:border-lime-400/50" />
            <button data-testid="reset-submit-button" type="submit" disabled={busy}
              className="w-full inline-flex items-center justify-center gap-2 bg-lime-400 text-black font-extrabold py-3.5 rounded-xl hover:bg-[#b0e600] active:scale-95 transition-all disabled:opacity-60">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Réinitialiser"}
            </button>
          </form>
        )}
        <Link to="/login" className="block text-center text-sm text-white/50 hover:text-white mt-6">Retour à la connexion</Link>
      </div>
    </div>
  );
}
